/* eslint-disable @typescript-eslint/no-explicit-any */
import { ColumnsType } from 'antd/es/table'
import {
  requestGetTumCanSync,
  requestSyncTradeUnionMember
} from 'app/api/tradeUnionMembers'
import { ITradeUnionMember } from 'app/api/tradeUnionMembers/model'
import R from 'app/assets/R'
import BaseText from 'app/components/common/BaseText'
import { IRefModal } from 'app/components/common/ModalComponent'
import { BaseForm } from 'app/components/common/forms/BaseForm'
import { BaseInput } from 'app/components/common/inputs/BaseInput'
import { BaseDatePicker } from 'app/components/common/pickers/BaseDatePicker'
import { BaseSelect } from 'app/components/common/selects/BaseSelect'
import { convertColumnTable } from 'app/components/tables/BaseTableReport/hook'
import { _DEV_ } from 'app/constant'
import { notificationController } from 'app/controllers/notification-controller'
import { TableTradeUnionMembersManagement } from 'app/model/trade-union-members-management'
import { TradeUnionMemberKeys } from 'app/react-query/query-key/tradeUnionMember'
import dayjs, { Dayjs } from 'dayjs'
import { isEmpty, isEqual } from 'lodash'
import { Pagination, ResponseType, initialPagination } from 'parkway-web-common'
import { useEffect, useMemo, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useQueryClient } from 'react-query'
import styled from 'styled-components'
import {
  IFilterTradeUnionList,
  PositionEnum,
  StatusActivitiesEnum,
  statusActivitiesOptions,
} from '../../type'
import { IDataFormUpdate } from './type'

function chunkArray(
  array: TableTradeUnionMembersManagement[],
  size: number,
): TableTradeUnionMembersManagement[][] {
  const chunkedArray: any[][] = []
  for (let i = 0; i < array.length; i += size) {
    chunkedArray.push(array.slice(i, i + size))
  }
  return chunkedArray
}

export const useHook = () => {
  const { t } = useTranslation()
  const query = useQueryClient()
  const [form] = BaseForm.useForm<IDataFormUpdate>()
  const refModal = useRef<IRefModal>({})

  const [isLoadingConfirm, setIsLoadingConfirm] = useState(false)

  const onSubmit = async () => {
    setTableData(prev => ({ ...prev, loading: true }))
    setIsLoadingConfirm(true)
    try {
      // const listDataSync = tableData.data?.filter(
      //   item => !!handleEmployeeStatus(item?.tinhTrangLamViec),
      // )
      const listDataSync = tableData.data ?? [];
      const list = chunkArray(listDataSync, 100)

      let listPromise: Promise<ResponseType<any>>[] = []

      list.forEach(item => {
        listPromise = listPromise.concat([
          requestSyncTradeUnionMember({
            data: item,
          }),
        ])
      })

      const res = await Promise.all(listPromise)

      if (res) {
        refModal?.current?.hide?.()
        query.invalidateQueries({
          queryKey: TradeUnionMemberKeys.allTradeUnionMember,
        })
        notificationController.success({
          message: 'Đồng độ dữ liệu thành công!',
        })
      }
    } catch (error) {
      _DEV_ && console.log('error', error)
    } finally {
      setTableData(prev => ({ ...prev, loading: false }))
      setIsLoadingConfirm(false)
    }
  }

  const [tableData, setTableData] = useState<{
    data: TableTradeUnionMembersManagement[]
    pagination: Pagination
    loading: boolean
  }>({
    data: [],
    pagination: initialPagination,
    loading: false,
  })
  const [filter, setFilter] = useState<IFilterTradeUnionList>({})

  useEffect(() => {
    const timer = setTimeout(() => {
      fetch()
    },  300)

    return () => clearTimeout(timer)
  }, [])

  const fetch = async () => {
    setTableData(prev => ({ ...prev, loading: true }))
    const res: ResponseType<ITradeUnionMember[]> = await requestGetTumCanSync()

    const data =
      res?.data?.map(item => ({
        ...item,
        tinhTrangSinhHoat: handleEmployeeStatus(item?.tinhTrangLamViec),
      })) ?? []

    const listFiler = data?.filter(item => {
      if (isEmpty(filter?.search) && !filter?.gender) return true
      if (!isEmpty(filter?.search)) {
        if (
          item?.fullName
            ?.toLowerCase()
            .includes(filter?.search?.toLowerCase() ?? '') ||
          item?.email
            ?.toLowerCase()
            .includes(filter?.search?.toLowerCase() ?? '') ||
          item?.dienThoaiDiDong
            ?.toString()
            ?.toLowerCase()
            .includes(filter?.search?.toLowerCase() ?? '') ||
          item?.cmnd
            ?.toLowerCase()
            .includes(filter?.search?.toLowerCase() ?? '')
        ) {
          return true
        }
      }

      return false
    })

    setTableData({
      data: listFiler,
      loading: false,
      pagination: initialPagination,
    })
  }
  
  const onChangeFilter = (newFilter: IFilterTradeUnionList) => {
    setFilter(newFilter)
  }

  useEffect(() => {
    fetch()
  }, [filter])

  const onChangeDateJoinByIndex = (day: Dayjs | null, index: number) => {
    setTableData(prev => {
      const newData = prev.data.map((item, idx) => {
        if (isEqual(idx, index)) {
          return {
            ...item,
            ngayVaoCongDoan: day?.toISOString(),
          }
        }
        return item
      })
      return {
        ...prev,
        data: newData,
      }
    })
  }

  const onChangeTinhTrangSinhHoatByIndex = (value: string, index: number) => {
    setTableData(prev => {
      const newData = prev.data.map((item, idx) => {
        if (isEqual(idx, index)) {
          return {
            ...item,
            tinhTrangSinhHoat: value,
          }
        }
        return item
      })
      return {
        ...prev,
        data: newData,
      }
    })
  }

  const onChangeJobTitleByIndex = (value: string, index: number) => {
    setTableData(prev => {
      const newData = prev.data.map((item, idx) => {
        if (isEqual(idx, index)) {
          return {
            ...item,
            chucVucongdoan: value,
          }
        }
        return item
      })
      return {
        ...prev,
        data: newData,
      }
    })
  }

  const columns: ColumnsType<TableTradeUnionMembersManagement> = useMemo(() => {
    return [
      convertColumnTable({
        title: t(R.strings.full_name),
        className: 'big-column',
        fixed: 'left',
        key: 'fullName',
        render: (_, record) => {
          return (
            <BaseText
              children={record?.fullName}
              fontWeight="semibold"
              fontSize="xs"
              colorText={
                !handleEmployeeStatus(record?.tinhTrangLamViec)
                  ? 'statesRedColor'
                  : 'collapseBackgroundColor'
              }
            />
          )
        },
      }),
      convertColumnTable({
        title: t(R.strings.CCCD),
        key: 'cmnd',
        className: 'big-column',
        render: (_, record) => {
          return (
            <BaseText
              children={record?.cmnd}
              fontWeight="semibold"
              opacity="0.7"
              colorText={
                !handleEmployeeStatus(record?.tinhTrangLamViec)
                  ? 'statesRedColor'
                  : 'primaryColor'
              }
            />
          )
        },
      }),
      convertColumnTable({
        title: 'Tên đơn vị',
        key: 'tenDonVi',
        classNameWidthColumnOverwrite: 'normal-column',
        render: (_, record) => {
          return (
            <BaseText
              children={!isEmpty(record?.tenDonVi) ? record?.tenDonVi : '-'}
              fontWeight="semibold"
              opacity="0.7"
              colorText={
                !handleEmployeeStatus(record?.tinhTrangLamViec)
                  ? 'statesRedColor'
                  : 'primaryColor'
              }
            />
          )
        },
      }),
      convertColumnTable({
        title: 'Mã quản lý',
        key: 'mql',
        className: 'big-column',
        render: (_, record) => {
          return (
            <BaseText
              children={record?.mql}
              fontWeight="semibold"
              opacity="0.7"
              colorText={
                !handleEmployeeStatus(record?.tinhTrangLamViec)
                  ? 'statesRedColor'
                  : 'primaryColor'
              }
            />
          )
        },
      }),
      convertColumnTable({
        title: t(R.strings.email),
        className: 'big-column',
        key: 'email',
        render: (_, record) => {
          return (
            <BaseText
              children={record?.email}
              fontWeight="semibold"
              opacity="0.7"
              colorText={
                !handleEmployeeStatus(record?.tinhTrangLamViec)
                  ? 'statesRedColor'
                  : 'primaryColor'
              }
            />
          )
        },
      }),

      convertColumnTable({
        title: t(R.strings.phone),
        className: 'big-column',
        key: 'dienThoaiDiDong',
        render: (_, record) => {
          return (
            <BaseText
              children={record?.dienThoaiDiDong}
              fontWeight="semibold"
              opacity="0.7"
              colorText={
                !handleEmployeeStatus(record?.tinhTrangLamViec)
                  ? 'statesRedColor'
                  : 'primaryColor'
              }
            />
          )
        },
      }),

      convertColumnTable({
        title: t(R.strings.birthday),
        className: 'big-column',
        key: 'ngaySinh',
        render: (_, record) => {
          return (
            <BaseText
              children={record?.ngaySinh}
              fontWeight="semibold"
              opacity="0.7"
              colorText={
                !handleEmployeeStatus(record?.tinhTrangLamViec)
                  ? 'statesRedColor'
                  : 'primaryColor'
              }
            />
          )
        },
      }),
      convertColumnTable({
        title: 'Tình trạng làm việc',
        className: 'big-column',
        key: 'tinhTrangLamViec',
        render: (_, record) => {
          return (
            <BaseText
              children={record?.tinhTrangLamViec}
              fontWeight="semibold"
              opacity="0.7"
              colorText={
                !handleEmployeeStatus(record?.tinhTrangLamViec)
                  ? 'statesRedColor'
                  : 'primaryColor'
              }
            />
          )
        },
      }),

      convertColumnTable({
        title: t(R.strings.date_of_union_entry),
        className: 'very-big-column',
        key: 'ngayVaoCongDoan',
        render: (_, record, index) => {
          return (
            <BaseDatePickerWrapper
              value={
                record?.ngayVaoCongDoan
                  ? dayjs(record?.ngayVaoCongDoan)
                  : undefined
              }
              onChange={value => onChangeDateJoinByIndex(value, index)}
              picker="year"
              disabled={!handleEmployeeStatus(record?.tinhTrangLamViec)}
            />
          )
        },
      }),
      convertColumnTable({
        title: t(R.strings.union_card_number),
        key: 'soTheDoanVien',
        classNameWidthColumnOverwrite: 'big-column',
        render: (_, record) => {
          return (
            <BaseInput
              placeholder={t(R.strings.enter_union_card_number)}
              value={record?.soTheDoanVien}
              onChange={e => {
                setTableData(prev => {
                  const newData = prev.data.map(item => {
                    if (item === record) {
                      return {
                        ...item,
                        soTheDoanVien: e?.target?.value,
                      }
                    }
                    return item
                  })
                  return {
                    ...prev,
                    data: newData,
                  }
                })
              }}
              disabled={!handleEmployeeStatus(record?.tinhTrangLamViec)}
            />
          )
        },
      }),
      convertColumnTable({
        title: t(R.strings.status_union_activities),
        key: 'tinhTrangSinhHoat',
        classNameWidthColumnOverwrite: 'very-big-column',
        render: (_, record, index) => {
          return (
            <BaseForm>
              <BaseForm.Item style={{ marginBottom: 0 }} hiddenLabel>
                <BaseSelect
                  placeholder={'Chọn tình trạng'}
                  width={260}
                  onChange={value =>
                    onChangeTinhTrangSinhHoatByIndex(value as string, index)
                  }
                  allowClear
                  value={record?.tinhTrangSinhHoat}
                  options={statusActivitiesOptions}
                  disabled={!handleEmployeeStatus(record?.tinhTrangLamViec)}
                />
              </BaseForm.Item>
            </BaseForm>
          )
        },
      }),
      convertColumnTable({
        title: t(R.strings.union_positions),
        key: 'chucVucongdoan',
        classNameWidthColumnOverwrite: 'big-column',
        render: (_, record, index) => {
          const position = record?.chucVucongdoan?.split(',')
          return (
            <BaseForm>
              <BaseForm.Item style={{ marginBottom: 0 }} hiddenLabel>
                <BaseSelect
                  placeholder={'Chức vụ công đoàn'}
                  options={Object.values(PositionEnum).map(position => ({
                    label: position,
                    value: position,
                  }))}
                  showSearch
                  mode="multiple"
                  value={!isEmpty(record?.chucVucongdoan) ? position : undefined}
                  onChange={e =>
                    onChangeJobTitleByIndex((e as string[])?.join(','), index)
                  }
                  disabled={!handleEmployeeStatus(record?.tinhTrangLamViec)}
                />
              </BaseForm.Item>
            </BaseForm>
          )
        },
      }),
    ]
  }, [t, tableData?.data])

  return {
    columns,
    tableData,
    onChangeFilter,
    filter,
    form,
    onSubmit,
    refModal,
    isLoadingConfirm,
  }
}
const BaseDatePickerWrapper = styled(BaseDatePicker)`
  width: 100%;
`

function handleEmployeeStatus(
  status: string | undefined,
): StatusActivitiesEnum | undefined {
  switch (status) {
    case 'Thôi việc':
      return StatusActivitiesEnum.DA_NGHI_VIEC
    case 'Đang làm việc (Do đơn vị ký)':
    case 'Đang làm việc (Hợp đồng lao động như viên chức)':
    case 'Đang làm việc (HĐLĐ lương khoán theo thỏa thuận)':
    case 'Đang làm việc (tạm ngưng phân công giảng)':
    case 'Đang làm việc (HĐLĐ lương khoán theo đơn giá)':
    case 'Đang làm việc cho ISB':
    case 'Đang làm việc (do ISB trả lương)':
    case 'Đang làm việc (Từ xa)':
    case 'Đang làm việc':
      return StatusActivitiesEnum.DANG_LAM_VIEC
    case 'Đi học tại nước ngoài (12 tháng trở lên)':
      return StatusActivitiesEnum.DI_HOC_CONG_TAC_TAI_NUOC_NGOAI_12_THANG_TRO_LEN
    case 'Đi học tại nước ngoài (1-12 tháng)':
      return StatusActivitiesEnum.DI_HOC_CONG_TAC_TAI_NUOC_NGOAI_DUOI_12_THANG
    case 'Đang làm việc (NLĐ cao tuổi)':
    case 'Đang làm việc (HĐLĐ chuyên môn - kéo dài)':
    case 'Đang làm việc (Kéo dài)':
      return StatusActivitiesEnum.KEO_DAI_CONG_TAC
    case 'Đang làm việc (Hợp đồng lao động theo sản phẩm)':
    case 'Tạm hoãn hợp đồng':
    case 'Đang làm việc (Hợp đồng dịch vụ)':
    case 'Mất':
    case 'Không liên lạc được':
    case 'Đang làm việc (Tình nguyện viên người nước ngoài)':
      return undefined
    case 'Nghỉ hưu':
      return StatusActivitiesEnum.NGHI_HUU
    case 'Nghỉ không lương':
      return StatusActivitiesEnum.NGHI_KHONG_LUONG
    case 'Nghỉ ốm, chữa bệnh':
      return StatusActivitiesEnum.NGHI_OM
    case 'Thai sản':
      return StatusActivitiesEnum.THAI_SAN
    default:
      return undefined
  }
}
